import { QrCode } from "lucide-react";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const MobileAppPromo = () => {
  const { product } = useProductDetail();

  if (!product?.mobile_upload_info) return null;

  const { title, items } = product.mobile_upload_info;

  return (
    <div className="space-y-1">
      <h2 className="font-medium text-sm my-4">{title}</h2>
      <a
        href={items.app_store_url || items.google_play_url || "#"}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackGeneric("mobile_app_promo", "click")}
        className="border p-3 rounded-lg flex items-center gap-3 hover:shadow-md transition-shadow cursor-pointer"
        style={{
          background: `linear-gradient(to right, ${items.color}15, ${items.color}05)`,
          borderColor: `${items.color}40`,
        }}
      >
        <div className="w-16 h-16 bg-white p-2 rounded-lg border flex items-center justify-center shrink-0">
          {items.qr_code ? (
            <FallbackImage
              src={items.qr_code}
              alt="QR Code"
              width={56}
              height={56}
              className="w-full h-full object-contain"
            />
          ) : (
            <QrCode size={40} style={{ color: items.color }} />
          )}
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-gray-900 mb-1">{items.title}</h3>
          <p className="text-xs text-gray-600 mb-2">{items.subtitle}</p>
        </div>
      </a>
    </div>
  );
};

export default MobileAppPromo;
